import { Extension } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    authoredContent: {
      insertAuthoredContent: (name: string, avatar: string, date: string, label?: string) => ReturnType;
    };
  }
}

export const createAuthoredContent = (name: string, avatar: string, date: string, label = "Authored by") => [
  { type: 'text', text: label, marks: [{ type: 'bold' }] },
  { type: 'hardBreak' },
  {
    type: 'customImage',
    attrs: {
      src: avatar,
      alt: name,
      width: 32,
      height: 32,
      isAvatar: true,
      'data-image-id': `avatar-${Date.now()}`,
      'data-fallback-initials': name.split(' ').map(n => n[0]).join('').toUpperCase(),
      'data-expected-name': name
    }
  },
  { type: 'text', text: ' ' },
  { type: 'text', text: name },
  { type: 'hardBreak' },
  { type: 'text', text: date, marks: [{ type: 'italic' }] }
];

export const AuthoredContentExtension = Extension.create({
  name: 'authoredContent',

  addCommands() {
    return {
      insertAuthoredContent:
        (name: string, avatar: string, date: string, label: string = 'Authored by') =>
        ({ commands, state }) => {
          const { $from } = state.selection;
          
          for (let depth = $from.depth; depth > 0; depth--) {
            const node = $from.node(depth);
            if (node.type.name === 'imagePlaceholder') {
              return false;
            }
          }
          
          let layoutNode = null;
          
          for (let depth = $from.depth; depth > 0; depth--) {
            const node = $from.node(depth);
            if (node.type.name === 'layout') {
              layoutNode = node;
              break;
            }
          }

          const authoredContent = createAuthoredContent(name, avatar, date, label);
          const content = { type: 'paragraph', content: authoredContent };

          if (layoutNode) {
            const { from, to } = state.selection;
            return commands.insertContentAt({ from, to }, authoredContent);
          } else {
            return commands.insertContent(content);
          }
        },
    };
  },
});
